<template lang="pug">
  navigation-tabs(:tabs="tabs")
</template>

<script>
import NavigationTabs from '../shared/NavigationTabs'

export default {
  components: {
    NavigationTabs
  },
  data() {
    return {
      tabs: [
        {path: '/account/personal', icon: 'account-settings', title: 'account.tabs.personal'},
        {path: '/account/security', icon: 'lock', title: 'account.tabs.security'}
      ]
    }
  }
}
</script>
